class ReadMore {
	constructor() {
		this.content = document.querySelectorAll('.js-read-more');
		this.originalContentArr = [];
		this.truncatedContentArr = [];
		this.moreLink = 'Read More';
		this.lessLink = 'Read Less';
		this.init();
	}

	init() {
		this.truncateText();
	}

	countWords(str) {
		return str.split(/\s+/).length;
	}

	ellipseContent(str, wordsNum) {
		return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
	}

	truncateText() {
		for (let i = 0; i < this.content.length; i++) {
			const originalContent = this.content[i].innerHTML;
			const numberOfWords = this.content[i].dataset.rmWords;
			const truncateContent = this.ellipseContent(originalContent, numberOfWords);
			const originalContentWords = this.countWords(originalContent);

			this.originalContentArr.push(originalContent);
			this.truncatedContentArr.push(truncateContent);

			if (numberOfWords < originalContentWords) {
				this.content[i].innerHTML = this.truncatedContentArr[i];
				this.createLink(i);
			}
		}
		this.handleClick(this.content);
	}

	createLink(index) {
		const linkWrap = document.createElement('span');
		linkWrap.className = 'read-more__link-wrap';
		linkWrap.innerHTML = `<button id="read-more_${index}" class="read-more__link" tabindex="0">${this.moreLink}</button>`;
		this.content[index].parentNode.insertBefore(linkWrap, this.content[index].nextSibling);
	}

	handleClick(el) {
		const readMoreLink = document.querySelectorAll('.read-more__link');

		readMoreLink.forEach((item) => {
			item.addEventListener('click', () => {
				const moreLinkID = item.getAttribute('id');
				let index = moreLinkID.split('_')[1];

				el[index].classList.toggle('is-expanded');

				if (item.dataset.clicked !== 'true') {
					el[index].innerHTML = this.originalContentArr[index];

					item.innerHTML = this.lessLink;
					item.dataset.clicked = true;
				} else {
					el[index].innerHTML = this.truncatedContentArr[index];
					item.innerHTML = this.moreLink;
					item.dataset.clicked = false;
				}
			});
		});
	}
}


window.addEventListener('DOMContentLoaded', () => {
    const readMoreInstance = new ReadMore();
})